import { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import SelectForm from '@Components/formsy/Select';
import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker';

const PEKEY_PROPERTY_OPTIONS = [
  { value: 'Sub 1', label: 'Sub 1' },
  { value: 'Sub 2', label: 'Sub 2' },
  { value: 'Sub 3', label: 'Sub 3' },
]

export default function MediaAlpha({ name, data = {} }) {
  const [apiKey, setApiKey] = useState(data.apiKey || '')
  const [peKeyProperty, setPeKeyProperty] = useState(data.peKeyProperty || 'Sub 2')
  const [host, setHost] = useState(data.host || 'insurance-exchange.mediaalpha.com')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Api Key</Label>
          <Input
            name='apiKey'
            value={apiKey}
            onChange={setApiKey}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>host</Label>
          <Input
            name='host'
            value={host}
            onChange={setHost}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>pekey property</Label>
          <SelectForm
            name='peKeyProperty'
            options={PEKEY_PROPERTY_OPTIONS}
            value={peKeyProperty}
            onChange={setPeKeyProperty}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ apiKey, host }}
    />
  </>
}
